var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center align-items-md-stretch py-2 py-md-0 right-side"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }